import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 0H12V2H13C16.866 2 20 5.13401 20 9V10H22V9C22 4.02944 17.9706 0 13 0Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10 2H4V24H20V12H18V18H6V4H10V2ZM13.0039 20V22.0039H11V20H13.0039Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 4H12V6H13C14.6569 6 16 7.34315 16 9V10H18V9C18 6.23858 15.7614 4 13 4Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.0039 8H12V10.0039H14.0039V8Z"}}]};

const HotspotWaveFilled = Vue.extend<IconProps>({
  name: 'HotspotWaveFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'hotspot-wave-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default HotspotWaveFilled;
